import { Box } from '@mui/material';
import ChatFlowAgentEdit from 'components/@home/@settings/Tabs/ChatFlowAgentEdit';
import AgentWorkspace from 'components/@home/@settings/Tabs/Agents/AgentWorkspace';
import Loading from 'components/common/Loading';
import { bool, func, object } from 'prop-types';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import agenticSectionPath from 'utils/agenticSectionPath';

const loadingSx = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 320,
};

const shellSx = {
  flex: '1 1 0',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

const ChatFlowFlowRoute = ({
  authCompany = null,
  chatFlows,
  chatFlowsLoaded = false,
  chatFlowEntityTypes,
  chatFlowIntents,
  chatFlowIntegrations,
  actions = null,
  onBackToList,
  onCreateSkill = null,
  onCreateTool = null,
  onCreateKnowledge = null,
}) => {
  const navigate = useNavigate();
  const { flowId } = useParams();
  const flow = flowId ? chatFlows?.[flowId] : null;

  useEffect(() => {
    if (!flowId || !chatFlowsLoaded) return;
    if (!flow) {
      navigate(agenticSectionPath(authCompany), { replace: true });
    }
  }, [flowId, flow, chatFlowsLoaded, navigate, authCompany]);

  if (!chatFlowsLoaded || !flow) {
    return (
      <Box sx={loadingSx}>
        <Loading size={48} />
      </Box>
    );
  }

  if (flow.mode === 'agent' && flow.agent) {
    return (
      <Box sx={shellSx}>
        <ChatFlowAgentEdit
          agentId={String(flow.agent)}
          flow={flow}
          actions={actions}
          onBackToList={onBackToList}
          chatFlows={chatFlows}
          chatFlowEntityTypes={chatFlowEntityTypes}
          chatFlowIntents={chatFlowIntents}
          chatFlowIntegrations={chatFlowIntegrations}
          onCreateSkill={onCreateSkill}
          onCreateTool={onCreateTool}
          onCreateKnowledge={onCreateKnowledge}
          authCompany={authCompany}
        />
      </Box>
    );
  }

  return (
    <Box sx={shellSx}>
      <AgentWorkspace
        flow={flow}
        onBackToList={onBackToList}
        chatFlows={chatFlows}
        chatFlowEntityTypes={chatFlowEntityTypes}
        chatFlowIntents={chatFlowIntents}
        chatFlowIntegrations={chatFlowIntegrations}
        authCompany={authCompany}
      />
    </Box>
  );
};

ChatFlowFlowRoute.propTypes = {
  authCompany: object,
  chatFlows: object.isRequired,
  chatFlowsLoaded: bool,
  chatFlowEntityTypes: object.isRequired,
  chatFlowIntents: object.isRequired,
  chatFlowIntegrations: object.isRequired,
  actions: object,
  onBackToList: func.isRequired,
  onCreateSkill: func,
  onCreateTool: func,
  onCreateKnowledge: func,
};

export default ChatFlowFlowRoute;
